const DEFAULT_LANGUAGE = 'en-gb';

export const LOCATION_FILTER = { DEFAULT_LANGUAGE };
